import invariant from 'tiny-invariant';

export function obfuscateProjectId(projectId) {
  if (typeof projectId === 'number') {
    projectId = `${projectId}`;
  }
  invariant(typeof projectId === 'string');
  if (!projectId.match(/^\d+$/)) {
    // Assume it's already obfuscated...
    return projectId;
  }
  invariant(typeof window.btoa === 'function');
  return window.btoa(projectId);
}

export function deobfuscateProjectId(projectId) {
  if (typeof projectId === 'number') {
    // Already deobfuscated
    return `${projectId}`;
  }
  invariant(typeof projectId === 'string');
  if (projectId.match(/^\d+$/)) {
    // Already deobfuscated
    return projectId;
  }
  invariant(typeof window.atob === 'function');
  return window.atob(projectId);
}
